module.exports = __webpack_public_path__ + "static/media/poster3.7660d7e0.jpg";